export { default } from './TemplateDetails';
